export const enum LoginPage {
  MAIN_PAGE,
  FORGOT_PASSWORD,
  VERIFICATION,
  RESET_PASSWORD
}
